import SEO_PRODUCT from '@constants/seoProduct';

const PRODUCT_SLUGS = Object.keys(SEO_PRODUCT);

const getProductSlugFromUrl = () => {
  const { pathname } = window.location;

  for (const slug of PRODUCT_SLUGS) {
    const regex = new RegExp(`/${slug}(-[\\w-]*)?/`);
    const hasSlug = regex.test(pathname);
    if (hasSlug) return slug;
  }

  return null;
};
export default getProductSlugFromUrl;
